import Component from './Invitations';

export default Component;
